<template>
  <el-container>
    <el-header>
      <div class="h-left">
        <el-form class="form" ref="form" :model="form" label-width="120px">
          <el-form-item label="选择楼栋：" class="form-item">
            <el-select v-model="form.type" style="width:150px;">
              <el-option label="所有楼栋" value="0"></el-option>
              <el-option label="A座" value="1"></el-option>
              <el-option label="B座" value="2"></el-option>
              <el-option label="C座" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择楼层：" class="form-item">
            <el-input type="text" v-model="form.msg"></el-input>
          </el-form-item>
          <el-form-item label="设备编号：" class="form-item">
            <el-input type="text" v-model="form.statue"></el-input>
		  </el-form-item>
		  <el-form-item class="form-item">
            <el-button type="primary" size="mini" style="margin-right: 10px;"> 查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-header>
    <el-main :style="`height:${treeHeight}px;`">
      <div v-for="(item,index) in tableData" :key="index"
        style="width: 32%;height: 200px;border: 1px solid #fff;margin: 10px;float:left;">
        <div style="float: left;width: 40%;height: 180px">
          <img style="width: 100%;height: 100%;" src="../../../public/static/vince/images/kongtiao/timg.jpg" alt="">
        </div>
        <div style="float: left;width: 60%;">
          <div class="m-item">
            <span style="font-size: 20px;font-weight: bold;line-height: 30px;">{{item.DeviceName}}</span>
            <br>
            <span style="font-size: 14px;">{{item.name}}</span>
          </div>
		  <div class="box_msg">
			<div class="msgInfo" style="padding-left: 10px;">
				<span>开关：
				<span style="color: red;">{{item.switch}}</span>
				</span>
				<span>位置：{{item.address}}</span>
			</div>
			<div class="msgInfo">
				<span>故障状态：
				<span style="color: green;">{{item.trouble}}</span>
				</span>
				<span>手 自 动 ： {{item.zidong}}</span>
			</div>
		  </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        treeHeight: "",
        form: {
          msg: "",
          type: "",
          statue: ""
        },
        tableData: [{
          name: '新风机',
          switch: '关闭',
          DeviceName: 'CP-1F-1',
          address: 'D座-1F',
          trouble: '正常',
          status: 1,
          zidong: '手动'
        }, {
          name: '新风机',
          switch: '关闭',
          DeviceName: 'CP-1F-1',
          address: 'D座-1F',
          trouble: '正常',
          status: 1,
          zidong: '手动'
        }, {
          name: '新风机',
          switch: '关闭',
          DeviceName: 'CP-1F-1',
          address: 'D座-1F',
          trouble: '正常',
          status: 1,
          zidong: '手动'
        }, {
          name: '新风机',
          switch: '关闭',
          DeviceName: 'CP-1F-1',
          address: 'D座-1F',
          trouble: '正常',
          status: 1,
          zidong: '手动'
        }, {
          name: '新风机',
          switch: '关闭',
          DeviceName: 'CP-1F-1',
          address: 'D座-1F',
          trouble: '正常',
          status: 1,
          zidong: '手动'
        }, {
          name: '新风机',
          switch: '关闭',
          DeviceName: 'CP-1F-1',
          address: 'D座-1F',
          trouble: '正常',
          status: 1,
          zidong: '手动'
        }, ]
      }
    },
    methods: {
      handleClick() {}
    },
    mounted() {
      window.onresize = () => {
        this.treeHeight = document.documentElement.clientHeight - 157;
      }
      this.treeHeight = document.documentElement.clientHeight - 157;
    }
  }

</script>